<template>
  <section>
    <h2>Budget</h2>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FrontofficeBudget'
})
</script>

<style scoped>
</style>


